/* eslint-disable max-lines-per-function */
import EventClass from "common/utils/ui/event-class";
import ScrollToElement from "common/utils/ui/scroll-to-element";
import madeStore from "components/jiffy/vue-product-details-print/store/store";
import madeStoreAb from "components/jiffy/vue-product-details-print-ab/store/store";
import "./product-details-upload-button-static.scss";

class ProductDetailsUploadButtonStatic extends EventClass {
  #abMonetization = ".js-ab-made-monetization-enabled";

  #appSelector = "#vue-product-details-print";

  #frontUploadSelector = "#field-artwork-upload-front";

  #uploadButton = ".js-product-details-upload-button-static";

  #artworkExists = false;

  #eventCaller = null;

  get $abMonetizationEnabled() {
    return document.querySelector(this.#abMonetization);
  }

  get $uploadButton() {
    return document.querySelector(this.#uploadButton);
  }

  event(e) {
    super.event(e);
    this.#eventCaller = e.currentTarget;
    document.querySelector(this.#frontUploadSelector).click();
  }

  init() {
    if (!this.$uploadButton) return;

    if (this.$abMonetizationEnabled) {
      madeStoreAb.subscribe(() => {
        const { getters } = madeStore;

        const isFrontLoaded = getters["artwork_front/artworkExists"];
        const isBackLoaded = getters["artwork_back/artworkExists"];
        const artworkExists = isFrontLoaded || isBackLoaded;
        this.#artworkExists = artworkExists;

        setTimeout(() => {
          // Recheck visibility after state update
          this.toggleButtonsVisibility();

          // Scroll to the made app if artwork added and the event caller is current button
          if (this.#artworkExists && this.#eventCaller) {
            this.#eventCaller = null;
            ScrollToElement.scrollIntoViewBySelector(this.#appSelector);
          }
        }, 0);
      });
    } else {
      madeStore.watch(
        state => {
          const isFrontLoaded = !!state.artwork_front.artwork || state.artwork_front.uploadArtwork;
          const isBackLoaded = !!state.artwork_back.artwork || state.artwork_back.uploadArtwork;
          return isFrontLoaded || isBackLoaded;
        },
        artworkExists => {
          this.#artworkExists = artworkExists;

          setTimeout(() => {
            // Recheck visibility after state update
            this.toggleButtonsVisibility();

            // Scroll to the made app if artwork added and the event caller is current button
            if (this.#artworkExists && this.#eventCaller) {
              this.#eventCaller = null;
              ScrollToElement.scrollIntoViewBySelector(this.#appSelector);
            }
          }, 0);
        },
        { immediate: true }
      );
    }
  }

  toggleButtonsVisibility() {
    const uploadButtonShown = !this.#artworkExists;
    this.$uploadButton.classList.toggle("hidden", !uploadButtonShown);
  }
}

export default () =>
  new ProductDetailsUploadButtonStatic({
    eventSelector: ".js-product-details-upload-button-static"
  });
